import React from 'react'
import styled from 'styled-components'
import Link from 'atoms/Link'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-content: space-between;
  margin-top: 16px;
`

const TextDiv = styled.div`
  margin-bottom: 16px;
  color: rgba(89, 100, 110, 1);
  font-size: 14px;
  line-height: 22px;
  align-self: center;
  text-align: center;
`

function GiftBottom(props) {
  const { className, children, linkUri, hasLinkToContest, onContestLink } = props

  return (
    <Wrapper className={className}>
      <TextDiv>{children}</TextDiv>
      {hasLinkToContest && !onContestLink && (
        <Link type="button" theme="primary" href={linkUri}>
          Play Now
        </Link>
      )}
    </Wrapper>
  )
}

GiftBottom.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  linkUri: PropTypes.string,
  hasLinkToContest: PropTypes.bool,
  onContestLink: PropTypes.bool.isRequired,
}

GiftBottom.defaultProps = {
  hasLinkToContest: true,
}

export default GiftBottom



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/components/GiftBottom.js